<script lang="ts">
	export let textHeavy = false;
</script>

<div class="row pb-2 pt-1">
	<div class="col-12 container" class:textHeavy>
		<slot />
	</div>
</div>

<style>
	.row {
		overflow-x: auto;
	}

	.container {
		max-width: 1096px;
		margin: 0 auto;
	}

	.textHeavy {
		max-width: 80ch;
	}

	:global(h1) {
		margin-bottom: 4rem;
	}
</style>
